import React, { useEffect, useState } from 'react';
import { Button, Form, Input, message, Modal } from 'antd';
import Title from 'antd/es/typography/Title';
import PropTypes from 'prop-types';
import { FieldBox, GreyText, FlexWrapper, CloseBtn } from '../../../theme/common_style';
import { addProjectRemarksApi, updateProjectRemarksApi } from '../../../redux/project/apiRoute';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useResponsiveModalWidth } from '../../../hooks/useResponsiveModalWidth';

const { TextArea } = Input;

const CreateNotes = ({ open, onCancel, edit, handleListing, seemore }) => {
  const [form] = Form.useForm();
  const location = useLocation();
  const { id } = location.state || {};
  const [loading, setLoading] = useState(false);
  const width = useResponsiveModalWidth(800);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const isEditMode = Boolean(edit);
      const apiPath = isEditMode ? updateProjectRemarksApi : addProjectRemarksApi;
      const idPath = isEditMode ? edit?.id : id;

      const res = await apiPath(idPath, values);
      if (res?.statusCode === 200) {
        toast.success(res?.message || `Successfully ${isEditMode ? 'updated' : 'added'}`);
        onCancel();
        handleListing();
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      console.error('Submission error:', error);
      toast.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (edit) {
      form.setFieldsValue({
        title: edit?.title,
        remarks: edit?.remarks
      });
    }
  }, [edit]);

  return (
    <Modal
      open={open}
      maskClosable={false}
      closable={false}
      centered
      destroyOnClose
      width={width}
      footer={false}>
      <Title level={4} style={{ margin: 0, textAlign: 'center' }}>
        {seemore ? 'View' : edit ? 'Edit' : 'Create'} Note
      </Title>
      <CloseBtn onClick={onCancel}>x</CloseBtn>
      <Form form={form} style={{ margin: '30px 0 0px' }} onFinish={handleSubmit}>
        <FieldBox>
          <label htmlFor="title">Title {!seemore && <span>*</span>}</label>
          <Form.Item name="title" rules={[{ required: true, message: 'Title is required' }]}>
            <Input readOnly={seemore} className="customHeight" placeholder="Enter title" />
          </Form.Item>
        </FieldBox>

        <FieldBox style={{ marginTop: '20px' }}>
          <FlexWrapper justify="space-between" width="100%">
            <label htmlFor="remarks">Description{!seemore && <span>*</span>}</label>
            {!seemore && <GreyText>Max 300 words</GreyText>}
          </FlexWrapper>
          <Form.Item
            name="remarks"
            rules={[
              { required: true, message: 'Description is required' },
              {
                validator: (_, value) => {
                  const trimmedValue = value ? value.trim() : '';
                  const wordCount = trimmedValue ? trimmedValue.split(/\s+/).length : 0;
                  if (!trimmedValue) {
                    return Promise.reject(new Error('Description cannot be empty'));
                  }
                  if (wordCount > 300) {
                    return Promise.reject(new Error('Maximum 300 words allowed'));
                  }
                  return Promise.resolve();
                }
              }
            ]}
            validateFirst>
            <TextArea
              style={{ resize: 'none' }}
              rows={10}
              readOnly={seemore}
              placeholder="Write details here"
              onChange={(e) => {
                const value = e.target.value;
                const trimmedValue = value.trim();
                const wordCount = trimmedValue ? trimmedValue.split(/\s+/).length : 0;

                if (!trimmedValue) {
                  message.warning('Description cannot be empty or only spaces.');
                } else if (wordCount > 300) {
                  message.warning('You have exceeded the 300 word limit.');
                }
              }}
            />
          </Form.Item>
        </FieldBox>

        {!seemore && (
          <FlexWrapper justify="end" gap="10px" margin="10px 0 0">
            <Button
              htmlType="submit"
              style={{ width: '140px' }}
              prefixCls="antCustomBtn"
              loading={loading}>
              {edit ? 'Update' : 'Save'}
            </Button>
          </FlexWrapper>
        )}
      </Form>
    </Modal>
  );
};

export default CreateNotes;

CreateNotes.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  edit: PropTypes.any,
  handleListing: PropTypes.func,
  seemore: PropTypes.bool
};
